import { apiDelete } from '../api';

const route = '/auth/sign_out';

const deleteSignOut = () => apiDelete(route);

export default deleteSignOut;
